import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ServiceStock } from 'src/app/service-stock.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { GotxGridData } from './gotx-grid-data';

@Component({
  selector: 'app-gotx-grid',
  templateUrl: './gotx-grid.component.html',
  styleUrls: ['./gotx-grid.component.css']
})
export class GotxGridComponent implements OnInit {

  @Input('data') data: any[];
  @Input('datafields') datafields: any[];
  @Input('rowId') rowId: string;
  @Input('scrollmode') scrollmode: string;
  @Input('datatype') datatype: string;
  @Input('columns') columns: Array<jqwidgets.GridColumn>;
  @Input('columngroups') columngroups: any[];
  @Input('columnsresize') columnsresize: boolean;
  @Input('sortable') sortable: boolean;
  @Input('width') width: string | number;
  @Input('height') height: string | number;
  @Input('selectionmode') selectionmode: string = "singlerow";
  @Input('pagermode') pagermode: string = "simple";
  @Input('pageable') pageable: boolean = false;
  @Input('theme') theme: string = this.services.theme.themeName;
  // @Input('scrollBarheight') scrollBarheight: string | number = 4;
  @Input('showaggregates') showaggregates: boolean = false;
  @Input('showstatusbar') showstatusbar: boolean = false;
  // @Input('statusbarheight') statusbarheight: number;
  @Input('autoheight') autoheight: boolean = false;
  @Input('autorowheight') autorowheight: boolean = false;
  @Input('filterable') filterable: boolean;
  @Input('showfilterrow') showfilterrow: boolean = false;

  @ViewChild('gotxGrid', { static: false }) gotxGrid: jqxGridComponent;

  @Output() selectedRow = new EventEmitter<GotxGridData>();

  constructor(private services: ServiceStock) { }

  source: any;
  dataAdapter: any;


  ngOnInit() {

    this.source = {
      localdata: this.data,
      datafields: this.datafields,
      id: this.rowId,
      datatype: this.datatype,
      columngroups: this.columngroups
    };

    this.dataAdapter = new jqx.dataAdapter(this.source);
  }

  reloadGrid(data) {
    this.source.localdata = data;
    this.gotxGrid.updatebounddata();
  }

  onCellclick(event: any): void {
    let selRow: GotxGridData = {
      datafield: event.args.datafield,
      rowindex: event.args.rowindex,
      columnindex: event.args.columnindex,
      value: event.args.value,
      row: this.gotxGrid.getrowdata(event.args.rowindex)
    };

    this.selectedRow.emit(selRow);
  }
}